import axios, { AxiosError } from 'axios';

import { ErrorCategory } from 'kashable-mobile-common';

import { setAccountBreached } from '../slices/userSlice';
import { store } from '../store';
import { addStateHistory } from '../utils/StateHistoryUtil';

import { Md5 } from 'ts-md5';

const base = axios.create({
    headers: {
        'X-Auth-Method': 'cookie',
        'X-Requested-With': 'XMLHttpRequest',
        'X-API-Version': '3'
    },
    baseURL: '/web',
});

base.interceptors.request.use((config) => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const agent = window.navigator.userAgent;

    // Check and remove the trailing / from the URL.

    /* not needed unit 2024-09-15 TODO turn back on and run full regression
    if (config.url) {
        config.url = config.url.replace(/\/$/, '');
    }
    */

    if(config.headers){
        config.headers['x-signature'] = Md5.hashStr(`${width}:${height}-${agent}`);
        config.headers['x-real-path'] = (config.baseURL || '') + config.url;
    }

    addStateHistory(`${config.method} ${config.url} start`);

    return config;
}, (error) => {
    return Promise.reject(error);
});

base.interceptors.response.use((response) => {
    const config = response.config;
    addStateHistory(`${config.method} ${config.url} 2XX`);

    return response;
}, (error:AxiosError<string>) => {
    if('config' in error){
        const config = error.config;
        if(config){
            addStateHistory(`${config.method} ${config.url} ${error.response?.status}`);
        }
    }

    // Check for 403 status with account_breached error code
    if (error.response?.status === 403) {
        try {
            const errorCategory = error.response.headers['X-Error-Category'] as ErrorCategory;
            // Check if response data is an object and has an error code
            if (errorCategory === 'USER_ACCOUNT_BREACHED') {
                store.dispatch(setAccountBreached());
            }
        } catch (e) {
            // Silently handle any parsing errors
            console.warn('Error parsing response data for account breach check:', e);
        }
    }

    return Promise.reject(error);
});

export {axios as axiosStatic};

export default base;
